import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "title", "pinSection", "pinInput", "loadingPanel", "loadingDots", "submitBtn", "errorMsg"]

  #escHandler  = null
  #cancelUrl   = null
  #dotsTimer   = null

  connect() {
    this.#escHandler = (e) => { if (e.key === "Escape") this.close() }
    document.addEventListener("keydown", this.#escHandler)
  }

  disconnect() {
    if (this.#escHandler) {
      document.removeEventListener("keydown", this.#escHandler)
      this.#escHandler = null
    }
    document.body.style.overflow = ""
  }

  open(event) {
    event.preventDefault()
    const btn = event.currentTarget

    // 취소 URL을 인스턴스 변수에 저장 (submit 시 사용)
    this.#cancelUrl = btn.dataset.cancelUrl
    this.titleTarget.textContent = btn.dataset.listingTitle

    // PIN 입력값 초기화 (이전 입력 잔존 방지)
    if (this.hasPinInputTarget) {
      this.pinInputTarget.value = ""
    }

    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  async submit(event) {
    event.preventDefault()
    if (!this.#cancelUrl) return

    const pin = this.hasPinInputTarget ? this.pinInputTarget.value.trim() : ""

    this.#setLoading(true)
    this.#clearError()

    let succeeded = false
    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
      const resp = await fetch(this.#cancelUrl, {
        method: "PATCH",
        headers: {
          "Content-Type":  "application/json",
          "X-CSRF-Token":  csrfToken || "",
          "Accept":        "application/json",
        },
        body: JSON.stringify({ pin }),
      })

      const data = await resp.json()

      if (data.success) {
        succeeded = true
        this.#setLoading(false)
        window.location.href = data.redirect || "/my-listings"
      } else {
        this.#showError(data.error || "취소 처리 중 오류가 발생했습니다.")
      }
    } catch (err) {
      this.#showError("네트워크 오류가 발생했습니다. 다시 시도해주세요.")
    } finally {
      if (!succeeded) this.#setLoading(false)
    }
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
    if (this.hasPinInputTarget) this.pinInputTarget.value = ""
    this.#clearError()
  }

  #setLoading(on) {
    if (this.hasLoadingPanelTarget) {
      if (on) {
        this.loadingPanelTarget.classList.remove("hidden")
        this.#startDots()
      } else {
        this.loadingPanelTarget.classList.add("hidden")
        this.#stopDots()
      }
    }
    if (this.hasSubmitBtnTarget) this.submitBtnTarget.disabled = on
  }

  #startDots() {
    if (!this.hasLoadingDotsTarget) return
    let count = 0
    this.#dotsTimer = setInterval(() => {
      this.loadingDotsTarget.textContent = ".".repeat((count % 3) + 1)
      count++
    }, 500)
  }

  #stopDots() {
    if (this.#dotsTimer) { clearInterval(this.#dotsTimer); this.#dotsTimer = null }
    if (this.hasLoadingDotsTarget) this.loadingDotsTarget.textContent = ""
  }

  #showError(msg) {
    if (!this.hasErrorMsgTarget) return
    this.errorMsgTarget.textContent = msg
    this.errorMsgTarget.classList.remove("hidden")
  }

  #clearError() {
    if (!this.hasErrorMsgTarget) return
    this.errorMsgTarget.textContent = ""
    this.errorMsgTarget.classList.add("hidden")
  }

  closeOnOverlay(event) {
    if (event.target === event.currentTarget) this.close()
  }
}
